class RestMethods {
  get(url, params = null) {
    if (params) {
      url = new URL(url);
      for (const key of Object.keys(params)) {
        url.searchParams.append(key, params[key]);
      }
    }
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization:
            "e76b116429cb1dd7d498a6870170f2d630331aaeec5bfe35e6077de352ed9634",
        }),
      })
        .then((response) => {
          if (response.ok) {
            return resolve(response.json());
          } else {
            return reject(new Error("error while get url " + url));
          }
        })
        .catch((error) => {
          return reject(new Error(error.message + " " + url));
        });
    });
  }

  delete(url, body) {
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: "DELETE",
        body: JSON.stringify(body),
        headers: new Headers({
          "Content-Type": "application/json",
        }),
      })
        .then((response) => {
          if (response.ok) {
            return resolve(response.json());
          } else {
            return reject(new Error("error while delete url " + url));
          }
        })
        .catch((error) => {
          return reject(new Error(error.message));
        });
    });
  }

  post(url, body) {
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: "POST",
        body: JSON.stringify(body),
        headers: new Headers({
          "Content-Type": "application/json",
        }),
      })
        .then((response) => {
          if (response.ok) {
            return resolve(response.json());
          } else {
            return reject(new Error("error while post url " + url));
          }
        })
        .catch((error) => {
          return reject(Error(error.message));
        });
    });
  }

  multipartPost(url, body) {
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: "POST",
        body: body,
      })
        .then((response) => {
          if (response.ok) {
            return resolve(response.json());
          } else {
            return reject(new Error("error while post url " + url));
          }
        })
        .catch((error) => {
          return reject(Error(error.message));
        });
    });
  }

  put(url, body) {
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: "PUT",
        body: JSON.stringify(body),
        headers: new Headers({
          "Content-Type": "application/json",
        }),
      })
        .then((response) => {
          if (response.ok) {
            return resolve(response.json());
          } else {
            return reject(new Error("error while put url " + url));
          }
        })
        .catch((error) => {
          return reject(new Error(error.message));
        });
    });
  }
}

export default RestMethods;
